import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import {SxProps, Theme} from '@mui/material/styles';
import {kit, radius} from './tokens';
import type {RadiusKey} from './tokens';

interface SkeletonBlockProps {
  width?: number | string;
  height?: number | string;
  // Corner radius token (default 'sm').
  radius?: RadiusKey;
  sx?: SxProps<Theme>;
}

// Generic rounded placeholder block.
export const SkeletonBlock = ({
  width = '100%',
  height = 16,
  radius: radiusKey = 'sm',
  sx,
}: SkeletonBlockProps) => (
  <Skeleton
    variant="rounded"
    width={width}
    height={height}
    sx={[
      {borderRadius: `${radius[radiusKey]}px`},
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);

// List-card shaped placeholder matching the kit Card metrics: thumbnail +
// title line + meta line + status-pill stub.
export const SkeletonCard = ({sx}: {sx?: SxProps<Theme>}) => (
  <Box
    sx={[
      {
        backgroundColor: '#FFFFFF',
        border: `1px solid ${kit.line}`,
        borderRadius: `${radius.md}px`,
        padding: '16px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '12px',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}>
    <Skeleton
      variant="rounded"
      width={56}
      height={56}
      sx={{borderRadius: `${radius.sm}px`, flexShrink: 0}}
    />
    <Box sx={{flex: 1, minWidth: 0}}>
      <Skeleton variant="text" width="55%" height={22} />
      <Skeleton variant="text" width="35%" height={18} />
      <Skeleton
        variant="rounded"
        width={90}
        height={22}
        sx={{borderRadius: `${radius.pill}px`, marginTop: '8px'}}
      />
    </Box>
  </Box>
);
